export const BRAND = {
  name: 'StockVested',
  domain: 'stockvested.com',
  url: 'https://stockvested.com',
  supportEmail: 'support@stockvested.com',
  helloEmail: 'hello@stockvested.com',

  product: {
    auditor: 'Stock Auditor',
    journal: 'Journal',
    performance: 'Performance Metrics',
    proPlan: 'StockVested Pro',
  },

  tagline:
    'Stock research, journaling, and performance review tools for traders.',

  auditorSubtitle:
    'Generate a structured research snapshot for a ticker, then save it to your journal.',

  disclaimerShort:
    'StockVested is a research and journaling tool. It does not provide financial advice.',
};